import { API } from '@/api';
import { PAGE_SIZE, type ProjectTab, TAB_FILTERS } from './constants';

export const classes = {
  list: 'max-h-[500px] w-full overflow-auto p-2',
};

export async function fetchProjectsForTab(tab: ProjectTab) {
  return API.UnisonProjects.fetchUnisonProjects({
    pagination: { page: 1, pageSize: PAGE_SIZE },
    sorting: { sortBy: 'updatedAt', sortOrder: 'DESCENDING' },
    filters: [TAB_FILTERS[tab]],
  });
}
